export function routing($stateProvider) {
    $stateProvider.state('App.Wip', {
        url: '/WIP',
        component: 'wipComponent'
    });
}
routing.$inject = ['$stateProvider'];
